<script>
import Header from "@/components/Head"
import Footer from "@/components/Food"
import UploadFiles from "@/components/UploadFiles"
import {
  GetOrderInfo, GetItemDetailList, SubmitOrderPay, GetList, Add, GetPayAccount
} from "@/api/general-api"
import { getToken } from "@/utils/myAuth";
import EditForm from '@/views/individual/invoice/Edit.vue'
import Vue from 'vue'

export default {
  name: 'OrderPay',
  components: { Header, Footer, UploadFiles },
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE_API,
      userSelectData: {
        ID: null,
        IdNums: []
      },
      invoices: [],
      info: {
        OrderNo: '',
        CreateTime: 0,
        TotalPrice: 0,
        OtherPrice: 0,
        PriceAgioed: 0,
        PhaseAmt: 0,
        OrderAmt: 0,
        PayAmt: 0,
      },
      msg: "",
      paymentList: [],
      BankType: [],
      payAccountList: [],
      payObj: {
        Payment: 'Offline',
        PayFile: [],
        PayAmount: 0,
        UserInvoiceID: ''
      },
    }
  },
  created() {
    this.info = {}
    this.scrollTop = document.body.scrollTop
  },
  beforeDestroy() {
    document.body.scrollTo(0, this.scrollTop)
  },
  mounted() {
    document.body.scrollTo(0, 0)
    const id = this.$route.params.id || this.$route.query.id
    if (!id) {
      return this.$message.error('参数错误!');
    }
    const token = getToken();
    if (!token) {
      localStorage.setItem('frmUrl', window.location.href)
      return this.$router.push("/login");
    }
    this.handleGetOrderInfo(id)
    GetItemDetailList({ ItemCode: 'Payment' }).then(res => {
      let paymentList = []
      if (res.success) {
        paymentList = res.data
      }
      this.paymentList = paymentList
      this.handleGetList()
    })
    GetItemDetailList({ ItemCode: 'BankType' }).then(res => {
      let BankType = []
      if (res.success) {
        BankType = res.data
      }
      this.BankType = BankType
      this.getSystemPayAccount();

    })


  },
  render(h) {
    return (
      <el-container>
        <el-header class="order-layout">
          <Header title="订单支付" />
        </el-header>
        <el-main class="user-center">
          {this.renderOrderPayMain()}
        </el-main>
        <el-footer class="order-layout">
          <Footer />
        </el-footer>
      </el-container>
    )
  },
  methods: {
    renderOrderPayMain() {
      const {
        OrderNo,
        CreateTime,
        TotalPrice,
        OtherPrice,
        PriceAgioed,
        PhaseAmt,
        OrderAmt,
        PayAmt,
        ReceiveAmt
      } = this.info
      return (
        <div class="w">
          <el-row type="flex" align="center" class="pay-item">
            <span>订单编号:</span><strong class="text-primary">{OrderNo}</strong>
          </el-row>
          <el-row type="flex" align="center" class="pay-item">
            <span>下单时间:</span><strong class="text-primary">{CreateTime}</strong>
          </el-row>
          <el-row type="flex" align="center" class="pay-item">
            <span>订单原价:</span><strong class="text-danger text-monery">{TotalPrice}</strong>
          </el-row>
          <el-row type="flex" align="center" class="pay-item">
            <span>其他费用:</span><strong class="text-danger text-monery">{OtherPrice}</strong>
          </el-row>
          <el-row type="flex" align="center" class="pay-item">
            <span>优惠金额:</span><strong class="text-danger text-monery">{PriceAgioed}</strong>
          </el-row>
          {
            (PhaseAmt > 0 || PhaseAmt < 0) && (
              <el-row type="flex" align="center" class="pay-item">
                <span>修改差额:</span><strong class="text-danger text-monery">{PhaseAmt}</strong>
              </el-row>
            )
          }
          <el-row type="flex" align="center" class="pay-item">
            <span>应付金额:</span><strong class="text-danger text-monery">{OrderAmt}</strong>
          </el-row>
          {
            (ReceiveAmt > 0) && (
              <el-row type="flex" align="center" class="pay-item">
                <span>已付金额:</span><strong class="text-danger text-monery">{ReceiveAmt}</strong>
              </el-row>
            )
          }
          <el-row type="flex" align="center" class="pay-item no-border">
            <span>待付金额:</span><strong class="text-danger text-monery">{PayAmt}</strong>
          </el-row>
          <el-divider />
          {this.renderPayAccountList()}
          <el-divider />
          <el-row type="flex" align="center" class="pay-item">
            <span class="required">支付方式:</span>
            <el-row type="flex" align="center">
              {this.paymentList.map(item => {
                return <span class={{
                  'save-btn': this.payObj.Payment !== item.ItemValue,
                  'user-btn': this.payObj.Payment === item.ItemValue,
                  small: true,
                }}
                  onClick={() => this.payObj.Payment = item.ItemValue}>{item.ItemName}</span>
              })}
            </el-row>
          </el-row>
          <el-row type="flex" align="center" class="pay-item">
            <span class="required">支付金额:</span><el-input-number value={this.payObj.PayAmount} on-change={val => this.onPayAmountChange(val)} precision={2} step={0.5} min={0.0}></el-input-number>

          </el-row>
          <el-row type="flex" align="center" class="pay-item">
            <span class={{ required: this.payObj.Payment === 'Offline' }}>支付凭证:</span>
            <div>
              <upload-files
                files={this.payObj.PayFile}
                max={1}
                acceptFileTypes={['PNG', 'JPG', 'PDF']}
                on-filelist-change={this.onUploadFilesChange}
              />
            </div>
          </el-row>
          <el-row type="flex" align="center" class="pay-item no-border">
            <strong class="text-dark" style="margin-left:200px;">注：选择<strong class="text-primary">【线下转账】</strong>方式，必须上传<strong class="text-primary">【支付凭证】</strong>！</strong>

          </el-row>
          <el-row type="flex" align="center" class="" style="margin-left: 230px;">
            点击“立即支付”即视为您同意<a href='/Home/About/400_1067' target="_blank" class="text-primary under-line">《服务购买条款与条件》 </a>
          </el-row>
          <el-divider />

          <el-row type="flex" align="center" class="pay-item no-border">

            <div class="buy-btn" style="margin-left:300px;width:200px;" onClick={() => this.onSubmitOrderPay()}>立即支付</div>
          </el-row>
        </div>
      )
    },
    /** 开票信息移除 */
    renderUserInvoiced() {
      const { payObj: { UserInvoiceID }, invoices } = this
      return (
        <el-row type="flex" align="center" class="pay-item">
          <span class={{ required: this.payObj.Payment === 'Offline' }}>开票信息:</span>
          <div>
            <el-row type="flex" justify="flex-start" align="middle" style="flex-wrap:wrap;">
              {invoices.map(item => {
                const className = `invoice-item ${item.ID === UserInvoiceID ? 'selected' : ''}`
                return (
                  <div style="width:100%;margin:5px;" class={className} onClick={() => this.onInvoiceClick(item.ID)}>
                    <el-row type="flex" justify="flex-start" align="middle">
                      <span class="brackets">{item.InvoiceType}</span>
                    </el-row>
                    <el-row type="flex" justify="flex-start" align="middle">
                      <span class=""><i class="text-desc">发票抬头:</i>{item.CompanyName}</span>
                    </el-row>
                    <el-row type="flex" justify="flex-start" align="middle">
                      <span class=""><i class="text-desc">纳税人识别号:</i>{item.Certificate}</span>
                    </el-row>
                    <el-row type="flex" justify="flex-start" align="middle">
                      <span class=""><i class="text-desc">注册联系人:</i>{item.RegLinker}</span>
                    </el-row>
                    <el-row type="flex" justify="flex-start" align="middle">
                      <span class=""><i class="text-desc">注册电话号码:</i>{item.RegTel}</span>
                    </el-row>
                    <el-row type="flex" justify="flex-start" align="middle">
                      <span class=""><i class="text-desc">注册地址:</i>{item.RegAdd}</span>
                    </el-row>
                    <el-row type="flex" justify="flex-start" align="middle">
                      <span class=""><i class="text-desc">开户银行:</i>{item.DepositBank}</span>
                    </el-row>
                    <el-row type="flex" justify="flex-start" align="middle">
                      <span class=""><i class="text-desc">银行账号:</i>{item.BankAccount}</span>
                    </el-row>
                  </div>
                )
              })}
            </el-row>
            <div style="display:flex;align-items:center;" class="invoice-item h-center" onClick={() => this.handleOpenEditWnd()}>
              <i class="el-icon-circle-plus-outline" style="font-size:18px;margin-right:5px;" /><span>增加开票信息</span>
            </div>
          </div>
        </el-row>
      )
    },
    handleOpenEditWnd(obj) {
      const GirConstructor = Vue.extend(EditForm);
      const nodeObj = new GirConstructor();
      nodeObj.$mount(document.createElement("div"));
      document.body.appendChild(nodeObj.$el);
      nodeObj.Options(obj);
      nodeObj.Open((obj, close) => {
        this.handlePost(obj, close)
      });
    },
    /** 发送数据事件 */
    handlePost(data, close) {
      const postData = {
        Name: 'UserInvoice',
        data: JSON.stringify(data)
      }
      Add(postData).then(res => {
        if (!res.success) {
          return this.$message.error('操作失败：' + res.msg)
        }
        close()
        this.handleGetList()
        this.selectedInvoice = res.data.ID
      })
    },
    onInvoiceClick(ID) {
      this.payObj.UserInvoiceID = ID
    },
    /** 获取订单详情 */
    handleGetOrderInfo(id) {
      GetOrderInfo(id).then(res => {
        console.log('GetOrderInfo', res)
        if (!res.success) {
          return this.$message.error("订单信息获取失败：" + res.msg)
        }

        this.info = res.data
      })
    },
    /** 提交支付 */
    onSubmitOrderPay() {
      const { ID } = this.info
      const { Payment, PayAmount, PayFile, UserInvoiceID } = this.payObj
      if (!PayAmount) {
        return this.$message.error("请输入【支付金额】！")
      }
      if (Payment === 'Offline' && !PayFile.length) {
        return this.$message.error("【线下转账】方式必须要上传【支付凭证】！")
      }
      if (!UserInvoiceID) {
        return this.$message.error("缺少【开票信息】！")
      }
      SubmitOrderPay({ ID, Payment, UserInvoiceID, PayAmount, PayFile: JSON.stringify(PayFile) }).then(res => {
        if (!res.success) {
          return this.$message.error('订单支付提交失败：' + res.msg)
        }
        this.$message.success('订单支付提交成功！')
        // --支付成功后跳转回去
        setTimeout(() => {
          window.history.go(-1)
        }, 1000)
      })
    },
    /** 支付凭证改变事件 */
    onUploadFilesChange(files) {
      this.payObj.PayFile = files
    },
    onPayAmountChange(val) {
      this.payObj.PayAmount = val
    },
    showErrorMsg() {
      if (!this.userSelectData.ID) {
        return '参数错误：缺少ID!'
      }
      return this.msg;
    },
    getImgFullPath(url) {
      return url.toUpperCase().startsWith("HTTP") ? url : this.baseUrl + url
    },
    handleGetList() {
      const param = []
      const queryParam = {
        Name: 'UserInvoice',
        currentPage: 1,
        pageSize: 999,
        searchEntity: JSON.stringify(param)
      }
      GetList(queryParam).then((res) => {
        if (res.success) {
          this.invoices = [...res.data.rows]
          if (!this.payObj.UserInvoiceID) {
            this.payObj.UserInvoiceID = this.invoices[0]?.ID
          }
        }
      })
    },
    getSystemPayAccount() {
      GetPayAccount({}).then(res => {
        if (res.success) {
          this.payAccountList = res.data.map(x => {
            if (typeof x.AlipayQR === 'string' && x.AlipayQR) {
              x.AlipayQR = this.getImgFullPath(x.AlipayQR)
            }

            x.BankTypeObj = this.BankType.find(t => t.ItemValue.toString() === x.BankType.toString()) || { ItemName: x.BankType }
            return x;
          }).sort((a, b) => a.BankType > b.BankType ? 0 : -1)

        }
      })
    },
    renderPayAccountList() {
      const { payAccountList } = this;
      return (
        <el-row type="flex" class="pay-item">
          <span>收款账号:</span>
          <div style="flex:1;">
            <el-row type="flex" justify="flex-start" style="flex-wrap:wrap;width:100%;">
              {payAccountList.map(item => {
                return (
                  <div style="width:100%">
                    <div style="float：left;width:40%;margin:5px " class="fleft pay-account">
                      <el-row type="flex" justify="flex-start" align="middle">
                        <span class="brackets">  {item.BankTypeObj.ItemName}</span>
                      </el-row>
                      <el-row type="flex" justify="space-between">
                        <div>
                          <el-row type="flex" justify="flex-start" align="middle">
                            <span class=""><i class="text-desc">开户名称:  </i>  {item.BankName}</span>
                          </el-row>
                          <el-row type="flex" justify="flex-start" align="middle">
                            <span class=""><i class="text-desc">开户账号:  </i>  {item.Account}</span>
                          </el-row>
                          <el-row type="flex" justify="flex-start" align="middle">
                            <span class=""><i class="text-desc">开户银行:  </i>  {item.Bank}</span>
                          </el-row>
                        </div>
                        {typeof item.AlipayQR === 'string' && <div style="padding:3px;"><el-row type="flex" justify="flex-start" align="middle">
                          <img src={item.AlipayQR} style="width:120px;" />
                        </el-row>
                        </div>
                        }
                      </el-row>

                    </div>
                    <div style="float：left; width:300px"  class="fleft">
                      {/* <img src="http://ceulccc.com/UploadFiles/pic/wxzf.png" style="height: 400px;width: auto;" /> */}
                    </div>
                  </div>
                )
              })}
            </el-row>
          </div>
        </el-row>
      )
    },
  }
}
</script>
<style lang="scss">
.fleft {
  float: left;
}

.user-center {
  background-color: #f5f5f5;
  padding: 0;

  .w {
    margin: 20px auto;
    width: 1210px;
    background: #fff;
    border: 1px solid #dcdfe6;
    padding: 20px;
  }

  .pay-item {
    padding: 5px 10px;
    line-height: 30px !important;

    &>span {
      color: #666;
      font-size: 12px;
      width: 220px;
      text-align: left;
      box-sizing: border-box;
      padding: 0 12px 0 100px;
      margin-left: 100px;
      line-height: 30px !important;

      &.required::after {
        content: "*";
        color: #c10015;
        font-size: 20px;
      }
    }

    strong {
      color: #c10015;
      font-size: 14px;
      padding: 0 12px 12px 0;
    }
  }

  .pay-account {
    margin-bottom: 20px !important;
    padding: 5px;
    color: #000;

    &:nth-child(2n-1) {
      border-right: 1px dashed #dcdfe6;
    }
  }

  .invoice-item {
    border: 1px solid #dcdfe6;
    margin: 5px 0;
    padding: 0 5px;
    color: #000;
    cursor: pointer;

    &:hover {
      border-color: #083090a0;
      color: #083090a0;
    }

    &.selected {
      border-color: #083090;
      color: #083090;
    }

    &.h-center {
      justify-content: center;
    }

    .vidiver-row {
      display: inline-block;
      width: 1px;
      margin: 0 10px;
      height: 100%;
      min-height: 20px;
      background: linear-gradient(#ffffff, #999, #ffffff);
    }
  }
}
</style>
<style lang="scss" scoped></style>